import React, { useEffect, useState } from "react";

const RelationInfo = (props) => {
    const [selectedTab, setSelectedTab] = useState("relationInfo");

    useEffect(() => {
        if (props.relationInfo && props.relationInfo.length > 0) {
            setSelectedTab("relationInfo");
        } else if (props.faq && props.faq.length > 0) {
            setSelectedTab("faq");
        }
    }, [props]);

    const path = (pathItem) => {
        let pathlist = [];
        pathItem.map((x, index) => {
            pathlist.push(<span className='path-doc'>{x}</span>);
            if (index < pathItem.length - 1)
                pathlist.push(<i className='icoKdc12 next'></i>);
            return x;
        }
        );
        return (
            <div className="related-path">
                {pathlist}
            </div>
        );
    }

    const moveTo = (doc, tab) => {
        let link = "";
        if (tab === "faq")
            link = `faq/${doc.faqKindName}/${doc.faqID}`;
        else
            link = `${doc.menuPath}/${doc.manualId}`;
        window.open(encodeURI(link), '_blank');
    }

    return (props.relationInfo || props.faq) && (
        <div className="related-btm" style={props.style}>
            <div class="related-tab">
                {props.relationInfo?.length > 0 && 
                <div className={`related-title-wrap ${selectedTab === "relationInfo" ? "active" : ""}`} onClick={() => setSelectedTab("relationInfo")}>
                    <p className='related-title'>관련문서</p>
                    <p className="related-title-count">{props.relationInfo.length}</p>
                </div>
                }
                {props.faq?.length > 0 &&
                <div className={`related-title-wrap ${selectedTab === "faq" ? "active" : ""}`} onClick={() => setSelectedTab("faq")}>
                    <p className='related-title'>FAQ</p>
                    <p className="related-title-count">{props.faq.length}</p>
                </div>
                }
            </div>
            <ul className='related-list'>
                {selectedTab === "relationInfo" ? 
                    props.relationInfo.map(relation => {
                        const fullPath = JSON.parse(relation.fullPath || []);
                        return (
                            <li onClick={(e) => moveTo(relation, selectedTab)}>
                                <div className="related-list-title-wrap">
                                    <i className="icoKdc20 document"></i>
                                    <p className='related-list-title'>{relation.title}</p>
                                </div>
                                {path(fullPath)}
                            </li>
                        )
                    })
                    :
                    props.faq.map(faq => {
                        return (
                            <li onClick={(e) => moveTo(faq, selectedTab)}>
                                <div className="related-list-title-wrap">
                                    <i className="icoKdc20 document"></i>
                                    <p className='related-list-title'>{faq.question}</p>
                                </div>
                                <div className="related-path">
                                    <span className='path-doc'>{faq.faqKindName}</span>
                                </div>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}
export default RelationInfo;